<div *ngIf="visible" class="alert-card" [ngClass]="'alert-card-' + type">
  <div class="alert-card-content">
    <div class="alert-card-icon">
      <ng-container [ngSwitch]="type">
        <i *ngSwitchCase="'error'" class="fas fa-exclamation-circle"></i>
        <i *ngSwitchCase="'warning'" class="fas fa-exclamation-triangle"></i>
        <i *ngSwitchCase="'info'" class="fas fa-info-circle"></i>
        <i *ngSwitchCase="'success'" class="fas fa-check-circle"></i>
        <i *ngSwitchCase="'ai'" class="fas fa-robot"></i>
        <i *ngSwitchDefault class="fas fa-exclamation-circle"></i>
      </ng-container>
    </div>
    <div class="alert-card-message">
      <ng-container>
        <ng-container *ngIf="translationKey">{{ translationKey | transloco }}</ng-container>
        <ng-container *ngIf="!translationKey">{{ message }}</ng-container>
        <ng-container *ngIf="!message"><ng-content></ng-content></ng-container>
      </ng-container>
    </div>
  </div>
  <button *ngIf="dismissible" class="alert-card-dismiss" (click)="dismiss()" aria-label="Dismiss">
    <i class="fas fa-times"></i>
  </button>
</div>
